<template>
  <div class="d-contents">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
  }
</script> 